import { render, staticRenderFns } from "./space_entrance.vue?vue&type=template&id=2b78b998&scoped=true"
import script from "./space_entrance.vue?vue&type=script&lang=js"
export * from "./space_entrance.vue?vue&type=script&lang=js"
import style0 from "./space_entrance.vue?vue&type=style&index=0&id=2b78b998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78b998",
  null
  
)

export default component.exports